import { BookOpen } from 'lucide-react';
import React from 'react';

import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/Card';

export default function NotesPage() {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Header */}
        <div className="mb-8">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-lg bg-[#9B1421]/20 flex items-center justify-center">
              <BookOpen size={20} className="text-text-primary" />
            </div>
            <div>
              <h1 className="text-2xl font-bold text-[#EBFFEE]">Notes</h1>
              <p className="text-sm text-[#A9A3A3]">Journal entries and notes</p>
            </div>
          </div>
        </div>

        {/* Notes Content */}
        <Card className="bg-[#221F1F] border-[#504A4A]">
          <CardHeader>
            <CardTitle className="text-[#EBFFEE] flex items-center gap-2">
              <BookOpen className="w-5 h-5 text-rollops-accent" />
              Notes & Journal
            </CardTitle>
          </CardHeader>
          <CardContent className="!p-6">
            <div className="text-center py-12">
              <p className="text-white/80 mb-4">
                Your notes and journal entries will appear here soon.
              </p>
              <p className="text-sm text-white/80">
                Keep track of important information, training notes, and personal reflections.
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
  );
}
